enum Actions {
  DATASET_SET = 'dataset-set',
  DATASET_SET_MULTIPLE = 'dataset-set-multiple',
  FORCED_VALUES_SET = 'dataset-set-forced',
  DEFAULT_VALUES_SET = 'dataset-set-defaults',
  PROXIED_VALUES_SET = 'dataset-set-proxied',
  LOAD_PAGE = 'loadpage',
}

export default Actions;
